"use strict";

exports.__esModule = true;
exports.TextureAtlasRegion = exports.TextureAtlasPage = exports.TextureAtlas = void 0;

var _Texture = require("./Texture");

var _Utils = require("./Utils");

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var TextureAtlas = /*#__PURE__*/function () {
  function TextureAtlas(atlasText) {
    this.pages = new Array();
    this.regions = new Array();
    var reader = new TextureAtlasReader(atlasText);
    var entry = new Array(4);
    var page = null;
    var region = null;
    var pageFields = {};

    pageFields["size"] = function () {
      page.width = parseInt(entry[1]);
      page.height = parseInt(entry[2]);
    };

    pageFields["format"] = function () {// page.format = Format[tuple[0]]; we don't need format in WebGL
    };

    pageFields["filter"] = function () {
      page.minFilter = _Utils.Utils.enumValue(_Texture.TextureFilter, entry[1]);
      page.magFilter = _Utils.Utils.enumValue(_Texture.TextureFilter, entry[2]);
    };

    pageFields["repeat"] = function () {
      if (entry[1].indexOf('x') != -1) page.uWrap = _Texture.TextureWrap.Repeat;
      if (entry[1].indexOf('y') != -1) page.vWrap = _Texture.TextureWrap.Repeat;
    };

    pageFields["pma"] = function () {
      page.pma = entry[1] == "true";
    };

    var regionFields = {};

    regionFields["xy"] = function () {
      region.x = parseInt(entry[1]);
      region.y = parseInt(entry[2]);
    };

    regionFields["size"] = function () {
      region.width = parseInt(entry[1]);
      region.height = parseInt(entry[2]);
    };

    regionFields["bounds"] = function () {
      region.x = parseInt(entry[1]);
      region.y = parseInt(entry[2]);
      region.width = parseInt(entry[3]);
      region.height = parseInt(entry[4]);
    };

    regionFields["offset"] = function () {
      region.offsetX = parseInt(entry[1]);
      region.offsetY = parseInt(entry[2]);
    };

    regionFields["orig"] = function () {
      region.originalWidth = parseInt(entry[1]);
      region.originalHeight = parseInt(entry[2]);
    };

    regionFields["offsets"] = function () {
      region.offsetX = parseInt(entry[1]);
      region.offsetY = parseInt(entry[2]);
      region.originalWidth = parseInt(entry[3]);
      region.originalHeight = parseInt(entry[4]);
    };

    regionFields["rotate"] = function () {
      var value = entry[1];
      if (value == "true") region.degrees = 90;else if (value != "false") region.degrees = parseInt(value);
    };

    regionFields["index"] = function () {
      region.index = parseInt(entry[1]);
    };

    var line = reader.readLine(); // Ignore empty lines before first entry.

    while (line && line.trim().length == 0) {
      line = reader.readLine();
    } // Header entries.


    while (true) {
      if (!line || line.trim().length == 0) break;
      if (reader.readEntry(entry, line) == 0) break; // Silently ignore all header fields.

      line = reader.readLine();
    } // Page and region entries.


    var names = null;
    var values = null;

    while (true) {
      if (line === null) break;

      if (line.trim().length == 0) {
        page = null;
        line = reader.readLine();
      } else if (!page) {
        page = new TextureAtlasPage();
        page.name = line.trim();

        while (true) {
          if (reader.readEntry(entry, line = reader.readLine()) == 0) break;
          var field = pageFields[entry[0]];
          if (field) field();
        }

        this.pages.push(page);
      } else {
        region = new TextureAtlasRegion();
        region.page = page;
        region.name = line;

        while (true) {
          var count = reader.readEntry(entry, line = reader.readLine());
          if (count == 0) break;
          var _field = regionFields[entry[0]];
          if (_field) _field();else {
            if (!names) {
              names = [];
              values = [];
            }

            names.push(entry[0]);
            var entryValues = [];

            for (var i = 0; i < count; i++) {
              entryValues.push(parseInt(entry[i + 1]));
            }

            values.push(entryValues);
          }
        }

        if (region.originalWidth == 0 && region.originalHeight == 0) {
          region.originalWidth = region.width;
          region.originalHeight = region.height;
        }

        if (names && names.length > 0) {
          region.names = names;
          region.values = values;
          names = null;
          values = null;
        }

        region.u = region.x / page.width;
        region.v = region.y / page.height;

        if (region.degrees == 90) {
          region.u2 = (region.x + region.height) / page.width;
          region.v2 = (region.y + region.width) / page.height;
        } else {
          region.u2 = (region.x + region.width) / page.width;
          region.v2 = (region.y + region.height) / page.height;
        }

        this.regions.push(region);
      }
    }
  }

  var _proto = TextureAtlas.prototype;

  _proto.findRegion = function findRegion(name) {
    for (var i = 0; i < this.regions.length; i++) {
      if (this.regions[i].name == name) {
        return this.regions[i];
      }
    }

    return null;
  };

  _proto.setTextures = function setTextures(assetManager, pathPrefix) {
    if (pathPrefix === void 0) {
      pathPrefix = "";
    }

    for (var _iterator = _createForOfIteratorHelperLoose(this.pages), _step; !(_step = _iterator()).done;) {
      var page = _step.value;
      page.setTexture(assetManager.get(pathPrefix + page.name));
    }
  };

  _proto.dispose = function dispose() {
    for (var i = 0; i < this.pages.length; i++) {
      this.pages[i].texture.dispose();
    }
  };

  return TextureAtlas;
}();

exports.TextureAtlas = TextureAtlas;

var TextureAtlasReader = /*#__PURE__*/function () {
  function TextureAtlasReader(text) {
    this.lines = null;
    this.index = 0;
    this.lines = text.split(/\r\n|\r|\n/);
  }

  var _proto2 = TextureAtlasReader.prototype;

  _proto2.readLine = function readLine() {
    if (this.index >= this.lines.length) return null;
    return this.lines[this.index++];
  };

  _proto2.readEntry = function readEntry(entry, line) {
    if (!line) return 0;
    line = line.trim();
    if (line.length == 0) return 0;
    var colon = line.indexOf(':');
    if (colon == -1) return 0;
    entry[0] = line.substr(0, colon).trim();

    for (var i = 1, lastMatch = colon + 1;; i++) {
      var comma = line.indexOf(',', lastMatch);

      if (comma == -1) {
        entry[i] = line.substr(lastMatch).trim();
        return i;
      }

      entry[i] = line.substr(lastMatch, comma - lastMatch).trim();
      lastMatch = comma + 1;
      if (i == 4) return 4;
    }
  };

  return TextureAtlasReader;
}();

var TextureAtlasPage = /*#__PURE__*/function () {
  function TextureAtlasPage() {
    this.name = null;
    this.minFilter = _Texture.TextureFilter.Nearest;
    this.magFilter = _Texture.TextureFilter.Nearest;
    this.uWrap = _Texture.TextureWrap.ClampToEdge;
    this.vWrap = _Texture.TextureWrap.ClampToEdge;
    this.texture = null;
    this.width = 0;
    this.height = 0;
    this.pma = false;
  }

  var _proto3 = TextureAtlasPage.prototype;

  _proto3.setTexture = function setTexture(texture) {
    this.texture = texture;
    texture.setFilters(this.minFilter, this.magFilter);
    texture.setWraps(this.uWrap, this.vWrap);
  };

  return TextureAtlasPage;
}();

exports.TextureAtlasPage = TextureAtlasPage;

var TextureAtlasRegion = /*#__PURE__*/function (_TextureRegion) {
  _inheritsLoose(TextureAtlasRegion, _TextureRegion);

  function TextureAtlasRegion() {
    var _this;

    _this = _TextureRegion.apply(this, arguments) || this;
    _this.page = null;
    _this.name = null;
    _this.x = 0;
    _this.y = 0;
    _this.offsetX = 0;
    _this.offsetY = 0;
    _this.originalWidth = 0;
    _this.originalHeight = 0;
    _this.index = 0;
    _this.degrees = 0;
    _this.names = null;
    _this.values = null;
    return _this;
  }

  return TextureAtlasRegion;
}(_Texture.TextureRegion);

exports.TextureAtlasRegion = TextureAtlasRegion;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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